import React from "react";
import "../styles/AddFunds.css";

const AddFundsSection = () => {
  const message ="Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <>
      <section className="add-funds-section">
        <h1 className="funds-title">How to Add Funds to Your <span className="highlight">Reddy Anna</span> Account for <span className="highlight">Betting Purposes?</span></h1>
        <p className="funds-description">
  To place a wager, users must deposit funds into their registered account.
</p>
<ol className="funds-steps">
  <li>Log in to your account and click on the "Deposit" option.</li>
  <li>
    Select your preferred payment method from options like PhonePe, GPay, UPI, Net Banking, or Paytm, available for Indian customers.
  </li>
  <li>Enter the required details for the deposit.</li>
  <li>Confirm your deposit by clicking "Submit."</li>
</ol>
<p className="funds-note">
  Please note that by proceeding with a deposit, you acknowledge and accept the platform's associated charges.
</p>

        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section>
      <section className="whatsapp-section">
        <h1 className="whatsapp-title"><span className="highlight">Reddy Anna</span> Book WhatsApp Number</h1>
        <p className="whatsapp-description">
          Feel free to contact us.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section>

      <section className="placebet-section">
        {/* <h1 className="placebet-title">How to place bet on <span className="highlight">Reddy Anna</span> Book?</h1> */}
        <h1 className="placebet-title">How To Connect with <span className="highlight">Reddy Anna</span> Book?</h1>
        {/* <p className="placebet-description">
        Placing Bets on <span>Reddy Anna Book</span>: Bet on 1000+ Games and 150+ Live Casino Games Without Registration. The live games are conveniently showcased on the platform's dashboard. Simply choose a game, make your selection, and proceed to place your wager. For specific match-related bets, head to the Fancy Bet section after selecting the match, and confidently place your & wager on the team of your choice.
        </p> */}
        <p className="placebet-description">
        Click on the Button Below and Chat with our Sales team and get your credentials.
        </p>
        <a
         href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section>

      {/* <section className="choosebetween-section">
        <h1 className="choosebetween-title">At <span className="highlight">Reddy Anna</span> Choose Between Multiple <span className="highlight">Sports Games</span> and <span className="highlight">Live Casinos</span> to Bet on</h1>
        <p className="choosebetween-description">
        The Reddy Anna Cricket ID platform boasts an extensive collection of sports games, covering cricket, basketball, football, tennis, soccer, and more. You have the flexibility to place bets on any sports game or live match of your choice. Beyond sports, the platform also features live casinos, providing an opportunity to test your luck and potentially win big.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section> */}

      <section className="getintouch-section">
        <h1 className="getintouch-title">How to <span className="highlight">Get in Touch</span> with <span className="highlight">Reddy Anna</span> Book?</h1>
        <p className="getintouch-description">
        The contact information is available on the webpage. You can also reach us through any of the WhatsApp numbers provided below.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section>

      <section className="withdrawcash-section">
        <h1 className="withdrawcash-title">How to <span className="highlight">Withdraw Cash</span> From <span className="highlight">Reddy Anna?</span></h1>
        <p className="withdrawcash-description">
        Withdrawing your winnings is a straightforward process. Simply submit a valid withdrawal request using the registered contact details. Please note that withdrawal notifications will only be available on our official website. Before initiating a withdrawal, ensure that all outstanding wagers are settled and agree to the refund terms. A processing fee may apply to withdrawal requests.
        </p>
        <p className="withdrawcash-description">
        Reddy Anna Book is a trusted betting platform where you can register for your cricket ID online and follow the provided steps. While betting can be exciting, it’s important to play responsibly to avoid addiction. Manage your funds wisely and use your skills and luck to maximize your earnings. Enjoy 24/7 deposit and withdrawal options for a seamless gaming experience.
        </p>
        <p className="withdrawcash-description">
        To ensure accuracy, all details will be verified before processing your withdrawal. Funds will be credited directly to the bank account you have registered with us.
        </p>
        <a
          href={ContactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="contactus-button"
        >
          Contact Us @ 7777857777
        </a>
      </section>
    </>
  );
};

export default AddFundsSection;
